import { useContext } from 'react';
import { FiltersContext } from './Filters/FiltersContext';
import { FiltersFormValues } from './types/filter';

export { AuditLogFiltersForm } from './Filters/FiltersContext';

//  Hook: useAuditLogFilters
//  Description: Return all FiltersContext methods and values
//  Note: <AuditLogFiltersForm /> must be wrapped around the filters root level to be able to access its context
//
export function useAuditLogFilters() {
  return useContext(FiltersContext);
}

//
//  Hook: useAuditLogFilters
//  Description: Hooks you up with a FiltersContext value by field name and returns the value, field name, and methods that make it easier to update the specific field's value
//  Note: <AuditLogFiltersForm /> must be wrapped around the filters root level to be able to access its context
//
interface Field<T extends keyof FiltersFormValues> {
  name: T;
  value: FiltersFormValues[T];
  onChange: (event: React.ChangeEvent<any>) => void;
}

interface Helpers {
  setValue: (value: any) => void;
}

export function useAuditLogFilter<T extends keyof FiltersFormValues>(
  fieldName: T
): [Field<T>, Helpers] {
  const filters = useAuditLogFilters();

  const field = {
    name: fieldName,
    value: filters.values[fieldName],
    onChange: filters.onChange
  };

  const helpers = {
    setValue: (value: any) => filters.setFieldValue(fieldName, value)
  };

  return [field, helpers];
}
